import { RespiAllerValueType } from '@common/enums';

export const diagnosticReportKeysRequired = [
    RespiAllerValueType.conclusie,
    RespiAllerValueType.dossiersamenvatting,
    RespiAllerValueType.icd10,
    RespiAllerValueType.medicamenteusAdvies,
    RespiAllerValueType.nietMedicamenteusAdvies,
];

export const diagnosticReportKeysOptional = [
    RespiAllerValueType.aanvullendOnderzoek,
    RespiAllerValueType.individueleAanbevelingen,
    RespiAllerValueType.negatieveUitslagen,
    RespiAllerValueType.opmerkingenVoorHuisarts,
    RespiAllerValueType.positieveUitslagen,
];

export type SaveGradingResult = {
    type: RespiAllerValueType;
    value: string;
}[];

export type RespiAllerGradingDataV1 = {
    conclusie: string;
    dossiersamenvatting: string;
    'icd-10': string;
    individuele_aanbevelingen: string | null;
    medicamenteus_advies: string;
    niet_medicamenteus_advies: string;
    opmerkingen_voor_huisarts: string | null;
};

export const respiAllerValidIcd10Codes = ['J30.0', 'J30.1', 'J30.3', 'J30.4', 'J45', 'L20', 'R69'];
